"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onSelectedCrewOn = exports.onLeave = exports.crewUpdate = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var diveCrew_hero_sidecar_1 = require("@voyage/crew/diveCrew_hero-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var voyageSounds_sidecar_1 = require("@voyage/sounds/voyageSounds-sidecar");
var voyageSystems_sidecar_1 = require("@voyage/systems/voyageSystems-sidecar");
var voyageUiSubsystem_sidecar_1 = require("@voyage/ui/voyageUiSubsystem-sidecar");
function crewUpdate(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    var d = obj.heroState;
    assert_sidecar_1.assert.notNil(d);
    var useSystemTime = 2;
    d.useSystemTimer += ds;
    diveCrew_hero_sidecar_1.diveCrew_hero.setProgress(obj, d.useSystemTimer / useSystemTime);
    if (d.useSystemTimer > useSystemTime) {
        d.useSystemTimer -= useSystemTime;
        if (voyageSystems_sidecar_1.voyageSystems.testNoPower(obj)) {
            return;
        }
        var possibleReports = [];
        var status_1 = voyageGameStatus_sidecar_1.voyageGameStatus.get();
        var es = status_1.enemyShip;
        if (es.active) {
            possibleReports.push.apply(possibleReports, [
                'Enemy ship on radar!',
                'Ship class ' + es.class + ' sighted',
                '',
                'Enemy hull integrity at ' + es.hitpoints,
            ]);
        }
        if (possibleReports.length === 0) {
            possibleReports.push.apply(possibleReports, ['Nothing on radar', 'Nothing to report', '', 'Clear space ahead']);
        }
        else {
            voyageSounds_sidecar_1.voyageSounds.playCompWarning2();
        }
        var report = rando_sidecar_1.rando.sample(possibleReports);
        diveCrew_sidecar_1.diveCrew.say(obj, report);
    }
}
exports.crewUpdate = crewUpdate;
function onLeave(obj) {
    voyageUiSubsystem_sidecar_1.voyageUiSubsystem.setOpen(false);
}
exports.onLeave = onLeave;
function onSelectedCrewOn(obj) {
    // voyageUiSubsystem.setOpen(true, obj.tile)
}
exports.onSelectedCrewOn = onSelectedCrewOn;
